import { render, staticRenderFns } from "./DetailImageEdit.vue?vue&type=template&id=0dc97d33&scoped=true"
import script from "./DetailImageEdit.vue?vue&type=script&lang=js"
export * from "./DetailImageEdit.vue?vue&type=script&lang=js"
import style0 from "./DetailImageEdit.vue?vue&type=style&index=0&id=0dc97d33&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc97d33",
  null
  
)

export default component.exports